import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '@environment/environment';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class ChaseTransactionLogsService {
    private baseUrl: string;
    
    constructor(private http: Http, private getEnvVarService: GetEnvVarService) {
        //this.baseUrl = environment.Invoiceservicebaseurl;
        this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
    }

    // Method to get the Chase Transaction Logs
    GetChaseTransactionLogs(): Observable<any[]> {
        return this.http.get(this.baseUrl + `/api/GetChaseTransactionLogs`)
            .map(response => response.json())
            .catch(handleError);
    }
}

function handleError(error: any) {
    // log error
    // could be something more sofisticated
    let errorMsg = error.message || ``;
    console.error(errorMsg);

    // throw an application level error
    return Observable.throw(errorMsg);
}


// WEBPACK FOOTER //
// ./src/app/chase-transaction-logs/Service/chase-transaction-logs-service.ts